module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__page-map"
  }, [_c('div', {
    staticClass: "search",
    on: {
      "click": function($event) {
        _vm.isSearch = !_vm.isSearch
      }
    }
  }, [(!_vm.isSearch) ? _c('div', {
    staticClass: "search__magnifier"
  }) : _c('div', {
    staticClass: "search__close"
  })]), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideSmartSearch),
      expression: "hideSmartSearch"
    }],
    staticClass: "filter",
    class: {
      filter_active: _vm.isSearch
    }
  }, [_vm._t("filter")], 2), (_vm.isActive && _vm.points) ? _c('yandex-map', {
    staticClass: "map",
    attrs: {
      "cluster-options": _vm.$options.clusterOptions,
      "controls": [],
      "detailed-controls": _vm.$options.controls,
      "scroll-zoom": true,
      "coords": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "use-object-manager": true,
      "init-without-markers": false
    },
    on: {
      "map-was-initialized": _vm.onMapInitialized
    }
  }, _vm._l((_vm.points), function(point) {
    return _c('ymap-marker', {
      key: point.uniqId,
      attrs: {
        "cluster-name": "eventPoints",
        "marker-type": "placemark",
        "balloon-template": _vm.balloonLayout,
        "coords": point.coords,
        "hintContent": point.title,
        "icon": _vm.$options.icon,
        "marker-id": point.id
      }
    })
  }), 1) : _vm._e(), (_vm.showSpinner) ? _c('spinner', {
    staticClass: "spinner"
  }) : _c('div', {
    staticClass: "notification"
  }, [_vm._v(_vm._s(_vm.emptyText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8d93daa","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/map/Map.vue
// module id = de3ea13ce029236ee5c0
// module chunks = 0